@if (previsionesClon().length > 0) {
<table class="tabla">
  <thead>
    <tr>
      <th class="articulos-column">
        {{ 'COMPARTIDOS.PREVISIONES_TABLE.ARTICULO' | translate }}
      </th>
      @for (articulo of previsionesClon()[0].data; track $index) {
      <th [ngClass]="{ 'isFestivo': articulo.isFestivo }">
        {{ articulo.fecha | date: 'EEE, dd/MM/yyyy' }}
      </th>
      }
    </tr>
  </thead>

  <tbody>
    @for (item of previsionesClon(); track $index) {
    <tr>
      <td class="articulos-column" [attr.data-label]="'COMPARTIDOS.PREVISIONES_TABLE.ARTICULO' | translate">
        {{ item.descripcionArticulo }}
      </td>

      @for (articulo of item.data; track $index) {
      @if (!editable()) {
      <td [attr.data-label]="articulo.fecha | date: 'EEE, dd/MM/yyyy'">
        {{ articulo.huecos }}
      </td>
      } @else {
      <td [attr.data-label]="articulo.fecha | date: 'EEE, dd/MM/yyyy'">
        <mat-form-field class="input-form">
          <input [ngStyle]="{ color: articulo.huecos < 0 ? 'red' : 'black' }" type="number" min="0" matInput
            [(ngModel)]="articulo.huecos" (change)="onInputChange()" (keydown)="bloquearCientifica($event)" />
        </mat-form-field>
      </td>
      }
      }
    </tr>
    }
  </tbody>
</table>
}